import "./styles.scss";

import React from "react";
import { graphql, StaticQuery } from "gatsby";

const PopupInfo = ({ onClick, data }) => {
	const acfData = data?.nodes[0]?.acfOptionsOpcje?.optionsPage;

	return (
		acfData?.popupInfoDescription && (
			<div className="popup-info">
				<div className="popup-info__wrapper">
					<button type="button" onClick={onClick}>
						Akceptuję
					</button>
					<div className="container g-0">
						<div className="row g-0 align-items-center">
							{acfData?.popupInfoImage?.sourceUrl && (
								<div className="col-md-6">
									<img
										className="img-fluid"
										src={acfData?.popupInfoImage?.sourceUrl}
										alt=""
									/>
								</div>
							)}
							<div className="col-md-6">
								<div className="popup-info__inner">
									<h3>{acfData?.popupInfoHeader}</h3>
									<div
										dangerouslySetInnerHTML={{
											__html: acfData?.popupInfoDescription,
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	);
};

export default (props) => (
	<StaticQuery
		query={graphql`
			{
				data: allWp {
					nodes {
						acfOptionsOpcje {
							optionsPage {
								popupInfoImage {
									sourceUrl
								}
								popupInfoHeader
								popupInfoDescription
							}
						}
					}
				}
			}
		`}
		render={(data) => <PopupInfo {...data} {...props} />}
	/>
);
